module.exports = __webpack_public_path__ + "img/SE5560915448.5f61d218.svg";